// /* eslint-disable @typescript-eslint/no-unused-vars */
// "use client";
// import { Control, UseFormClearErrors } from "react-hook-form";
// import formatDate from "../../../utilities/helper";
// import { useFetchDriversAllData, useFetchDriversAllDataForPickupMerchant } from "../../../apis/driverApis";
// import { useFetchAllVehicle } from "../../../apis/pickupApis";
// import Section from "../../../components/common/Section";
// import NewinputField from "../../../components/NewInput";
// import NewSelectInput from "../../../components/NewSelectInput";

// const InfoRow = ({
//   label,
//   value,
//   className,
// }: {
//   label: string;
//   value: string;
//   className?: string;
// }) => (
//   <div className={`flex items-center gap-2 w-full ${className}`}>
//     <h2 className=" capitalize text-[#212121] text-sm font-normal">
//       {label} :
//     </h2>
//     <p className=" text-[#1E293B] text-sm text-end">{value}</p>
//   </div>
// );
// type Props = {
//   register: any;
//   setValue: any;
//   watch: any;
//   errors: any;
//   clearErrors?: UseFormClearErrors<any>;
//   control: Control<any>; // ✅ Add this
//   reset?: any; // ✅ Add this
//   pickupItem?: any;
// };
// const AssignDriver = ({
//   register,
//   errors,
//   setValue,
//   watch,
//   control,
//   reset,
//   clearErrors,
//   pickupItem,
// }: Props) => {
//   const { data: vehicleData, refetch: vehicleRefetch } = useFetchAllVehicle();
//   const vehicleListData = vehicleData ?? [];
//   const { data: driverData } = useFetchDriversAllDataForPickupMerchant(pickupItem?.clientId)
//   const driverListData = driverData ?? [];

//   return (
//     <div className="w-full py-4 px-6 space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]  ">
//       <div className=" h-[calc(100vh-13rem)] overflow-y-auto space-y-4">
//         <Section
//           className="col-span-6"
//           mainClassName="grid grid-cols-6 gap-4 border-[1.5px] border-[#D2D2D2] p-2 rounded-lg"
//           title="Pickup Information"
//         >
//           <InfoRow
//             className="col-span-2"
//             label="Pickup Id"
//             value={pickupItem?.pickupId}
//           />
//           <InfoRow className="col-span-2" label="Vehicle Type" value="Van" />
//           <InfoRow
//             className="col-span-2"
//             label="Order Reference"
//             value="#PRQ00123"
//           />
//           <InfoRow
//             className="col-span-3"
//             label="Scheduled Date"
//             value={`${formatDate(pickupItem?.pickupDate)}`}
//           />
//           <InfoRow
//             className="col-span-3"
//             label="Scheduled Time"
//             value={`${pickupItem?.timeSlot}`}
//           />
//           <InfoRow
//             className="col-span-6"
//             label="Pickup Location"
//             value={pickupItem?.fullAddress}
//           />
//         </Section>

//         <div className="grid grid-cols-2 gap-4">
//           <NewSelectInput
//             label="Select Driver"
//             name="driverId"
//             placeholder="Select Driver"
//             register={register}
//             selectOptions={driverListData?.map((driver: any) => ({
//               id: driver?.id,
//               value: driver?.id,
//               text: driver?.name,
//             }))}
//             clearErrors={clearErrors}
//             validation={{ required: "Driver is required" }}
//             error={errors.driverId}
//             disabled={!driverListData.length}
//             value={watch("driverId")}
//             setValue={(value: any) => {
//               setValue("driverId", value);
//               setValue('driverContact', driverData?.find((driver: any) => driver?.id === value)?.mobileNo)
//             }}
//           />
//           <NewinputField
//             type="number"
//             name="driverContact"
//             title="Contact"
//             placeholder="Enter Driver Contact"
//             disabled
//             value={watch('driverContact')}
//             register={register}
//             error={errors.driverContact}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AssignDriver;

/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import { useEffect, useState } from "react";
import { Control, UseFormClearErrors } from "react-hook-form";
import formatDate from "../../../utilities/helper";
import {
  useFetchDriversAllDataForPickupMerchant,
  useFetchDriversAllData,
  useFetchDriversByWarehouse,
} from "../../../apis/driverApis";
import { useFetchAllVehicle } from "../../../apis/pickupApis";
import Section from "../../../components/common/Section";
import NewinputField from "../../../components/NewInput";
import NewSelectInput from "../../../components/NewSelectInput";

const InfoRow = ({
  label,
  value,
  className,
}: {
  label: string;
  value: string;
  className?: string;
}) => (
  <div className={`flex justify-between items-center py-1.5 border-b border-slate-100 last:border-0 w-full gap-4 text-xs sm:text-sm ${className}`}>
    <span className="capitalize text-slate-500 font-medium">{label}</span>
    <span className="text-[#1E293B] font-semibold text-right break-all">{value || "—"}</span>
  </div>
);

type FormValues = {
  pickupId: string;
  driverId: string;
  vehicleId?: string;
  driverContact: string;
};

type Props = {
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  clearErrors?: UseFormClearErrors<any>;
  control: Control<any>;
  reset?: any;
  pickupItem?: any;
};

const AssignDriver = ({
  register,
  setValue,
  watch,
  errors,
  clearErrors,
  control,
  reset,
  pickupItem,
}: Props) => {
  const { data: vehicleData } = useFetchAllVehicle();
  const vehicleListData = vehicleData ?? [];

 const isReturn = pickupItem?.type === "return";
 const manifestType = pickupItem?.manifestType;

 const { data: allDrivers, isLoading: warehouseDriversLoading } = useFetchDriversByWarehouse(
   pickupItem?.warehouseId,
   manifestType === "OUTLET" && !isReturn,
 );

 const { data: merchantDrivers, isLoading: merchantDriversLoading } = useFetchDriversAllDataForPickupMerchant(
   manifestType !== "OUTLET" && !isReturn ? pickupItem?.clientId : undefined,
 );

 const { data: returnDrivers, isLoading: returnDriversLoading } = useFetchDriversAllData(
   "",
   isReturn,
 );

 const driversLoading = isReturn
   ? returnDriversLoading
   : manifestType === "OUTLET"
     ? warehouseDriversLoading
     : merchantDriversLoading;

 const driverListData = isReturn
   ? (returnDrivers ?? [])
   : manifestType === "OUTLET"
     ? (allDrivers ?? [])
     : (merchantDrivers ?? []);

  useEffect(() => {
    if (!pickupItem) {
      reset?.({
        pickupId: "",
        driverId: "",
        driverContact: "",
      });
      return;
    }

    setValue("pickupId", pickupItem.id || pickupItem.pickupId || "", {
      shouldValidate: false,
    });

    if (pickupItem.driverName && driverListData.length > 0 && !driversLoading) {
      const matchingDriver = driverListData.find(
        (driver: any) =>
          driver.name?.toLowerCase() === pickupItem.driverName?.toLowerCase() ||
          driver.code === pickupItem.driverCode,
      );
      if (matchingDriver) {
        setValue("driverId", matchingDriver.id, { shouldValidate: true });
        if (matchingDriver.mobileNo) {
          setValue("driverContact", matchingDriver.mobileNo);
        }
      } else {
        console.warn("No Matching Driver Found for", pickupItem.driverName);
      }
    }

    if (pickupItem.driverMobileNo) {
      setValue("driverContact", pickupItem.driverMobileNo);
    }
  }, [pickupItem, driverListData, driversLoading, setValue, reset]);

  useEffect(() => {
    const selectedDriverId = watch("driverId");
    if (!selectedDriverId || !driverListData.length || driversLoading) return;

    const selectedDriver = driverListData.find(
      (d: any) => d.id === selectedDriverId,
    );

    if (selectedDriver?.mobileNo) {
      setValue("driverContact", selectedDriver.mobileNo);
    }
  }, [
    watch("driverId"),
    driverListData,
    driversLoading,
    setValue,
    pickupItem,
    reset,
    
  ]);
  return (
    <div className="w-full py-4 px-2 sm:px-4 space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-3xl">
      <div className="space-y-4">
        {/* <Section
          className="w-full"
          mainClassName="flex flex-col border border-[#D2D2D2] p-3 rounded-2xl bg-white"
          title="Pickup Information"
        >
          <InfoRow
            label="Pickup Id"
            value={pickupItem?.pickupId}
          />
          <InfoRow label="Vehicle Type" value="Van" />
         
          <InfoRow
            label="Scheduled Date"
            value={
              pickupItem?.pickupDate ? formatDate(pickupItem.pickupDate) : "—"
            }
          />
          <InfoRow
            label="Scheduled Time"
            value={pickupItem?.timeSlot ?? "—"}
          />
          <InfoRow
            label="Pickup Location"
            value={pickupItem?.fullAddress ?? "—"}
          />
        </Section> */}

        <div className="grid grid-cols-2 gap-4">
          <NewSelectInput
          className="flex items-center gap-2 col-span-2"
            label="Select Driver"
            name="driverId"
            placeholder={
              driversLoading
                ? "Loading drivers..."
                : pickupItem?.driverName
                  ? `Currently: ${pickupItem.driverName}`
                  : "Select Driver"
            }
            register={register}
            selectOptions={
              (Array.isArray(driverListData) &&
                driverListData.map((driver: any) => ({
                  id: driver.id,
                  value: driver.id,
                  text: driver.name || driver.fullName || "Unnamed Driver",
                }))) ||
              []
            }
            clearErrors={clearErrors}
            validation={{ required: "Driver is required" }}
            error={errors.driverId}
            disabled={driversLoading || !driverListData.length}
            value={watch("driverId") ?? ""}
            setValue={(value: string) => {
              setValue("driverId", value);
              const driver = driverListData.find((d: any) => d.id === value);
              if (driver?.mobileNo) {
                setValue("driverContact", driver.mobileNo);
              }
            }}
          />

          <NewinputField
           className="flex items-center gap-2"
            type="text"
            name="driverContact"
            title="Contact"
            placeholder="Driver contact number"
            disabled={true}
            value={watch("driverContact") ?? ""}
            register={register}
            error={errors.driverContact}
          />
          <NewinputField
           className="flex items-center gap-2"
            type="text"
            name="vehicle_type"
            title="Vehicle Type"
            placeholder="Vehicle Type"
            disabled={true}
            value={watch("vehicle_type") ?? ""}
            register={register}
            error={errors.vehicle_type}
          />
        </div>
      </div>
    </div>
  );
};

export default AssignDriver;
